import * as React from 'react'
import { withStyles, WithStyles } from '@zn-material-ui'
import { RouteComponentProps } from 'react-router'
import { observer, inject } from 'mobx-react'

import LeftLogo from '../components/LeftLogo'
import BindingForm from './BindingForm'
import styles from './styles'
import { IProps as ILoginProps } from '../Login'

export interface IProps extends ILoginProps, RouteComponentProps {
  match: RouteComponentProps<{ token: string; from: string }>['match']
}

@inject('UserStore', 'AppStore')
@observer
class Binding extends React.Component<IProps & WithStyles<typeof styles>, any> {
  public render() {
    const { classes, ...props } = this.props
    return (
      <div className={classes.login}>
        <LeftLogo AppStore={props.AppStore} />
        <BindingForm {...props} />
      </div>
    )
  }
}

export default withStyles(styles)(Binding)
